<template>
	<section>
		<div class="lockMsg frame" v-if="!editVoucher">
			<fa :icon="['fas','triangle-exclamation']" />
			<p>Você não tem permissão para editar vouchers.</p>
		</div>
		<div :class="['frame',{ locked: !createEditTipoVoucher }]" ref="formtipoVoucher">
			<h3 v-if="tipoVoucher">{{ tipoVoucher.nomeTipoVoucher }}</h3>
			<form v-if="tipoVoucher">
				<div class="row no-padd">
					<div class="col-md-4 form-group">
						<input-control 
							v-model="tipoVoucher.nomeTipoVoucher" 
							name="Nome do Voucher" 
							label="Nome do Voucher"
							placeholder="Selecione" 
							required 
						/>
					</div>
					<div class="col-md-4 form-group">
						<select-control 
							v-model="tipoVoucher.tipo"
							name="Tipo de Voucher" 
							label="Tipo de Voucher" 
							:options="options.tiposVoucher" 
							placeholder="Selecione" 
							disabled
						/>
						<!-- <input-control v-model="tipoVoucher.tipo" name="Tipo de Voucher" label="Tipo de Voucher" required /> -->
					</div>
				</div>
				<div class="row no-padd">
					<div class="col-md-2 form-group">
						<select-control
							v-model="tipoVoucher.modelo"
							name="Modelo"
							:options="options.modelo"
							placeholder="Selecione"
							label="Modelo"
							disabled
						/>
					</div>
					<div class="col-md-2 form-group">
						<select-control
							v-model="tipoVoucher.nominal"
							name="Nominal"
							:options="options.nominal"
							placeholder="Selecione"
							label="Nominal"
							disabled
						/>
					</div>
					<div class="col-md-2 form-group">
						<input-control 
							v-model="tipoVoucher.duracaoDias" 
							name="Duração" 
							label="Duração (dias)" 
							required 
						/>
					</div>
					<div class="col-md-3 form-group">
						<select-control 
							label="Categoria Loja" 
							:options="options.categoriasLoja" 
							placeholder="Selecione"
							v-model="tipoVoucher.idCategoriaLoja" 
							disabled
						/>
					</div>
					<div class="col-md-3 form-group">
						<select-control 
							label="Tipo Desconto" 
							:options="options.tiposDesconto" 
							disabled
							placeholder="Selecione"
							v-model="tipoVoucher.idTipoDesconto" 
						/>
					</div>
				</div>
				<div class="row no-padd">
					<div class="col-md-12 form-group">
						<textarea-control v-model="tipoVoucher.descricaoVoucher" name="Descrição" label="Descrição" required />
					</div>
				</div>
				<div class="row no-padd">	
					<div class="col-md-2 form-group">
						<input-control 
							v-model="tipoVoucher.valor" 
							name="valor" 
							label="Valor (R$)" 
							type="number"
							@input="maskMoney($event,2,'valor')"
							:disabled="!!tipoVoucher.porcentagem"
							:required="!tipoVoucher.porcentagem"
						/>
					</div>
					<div class="col-md-2 form-group">
						<input-control 
							v-model="tipoVoucher.porcentagem" 
							name="porcentagem" 
							label="Porcentagem"
							type="number"
							@input="maskMoney($event,3,'porcentagem')"
							:disabled="!!tipoVoucher.valor"
							:required="!tipoVoucher.valor"
						/>
					</div>
				</div>
			</form>
			<footer>
				<div>
					<a href="#" class="btn btn-secondary" @click.prevent="clear()">Limpar</a>
				</div>
				<div>
					<a href="#" @click.prevent="saveTipoVoucher" class="btn btn-primary"> Salvar </a>
				</div>
			</footer>
		</div>
	</section>
</template>

<script>
import FinanceiroService from '@/services/financeiro.service';
import MarketplaceService from '@/services/marketplace.service.js'
import UserService from '@/services/user.service.js'
import MatriculaService from '@/services/matricula.service.js'
import { createSelectOptions } from '@/services/utils.service.js'

export default {
    props: {
			scope: {
				type: Object
			}
    },
    data() {
			return {
				editVoucher: false,
				createEditTipoVoucher: false,
				model: {
					nomeTipoVoucher: null,
					tipo: null,
					modelo: null,
					nominal: null,
					inicio: null,
					valor: null,
					porcentagem: null,
					duracaoDias: null,
					idTipoDesconto: null,
					idCategoriaLoja: null,
					descricaoVoucher: null
				},
				tipoVoucher: null,
				wait: {
					// tiposVoucher: false,
					categoriasLoja: false,
					tipoDesconto: false
				},
				options: {
					modelo: [
						{ value: "turma", label: "Turma" },
						{ value: "categoria", label: "Categoria" },
					],
					nominal: [
						{ value: 1, label: 'Sim' },
						{ value: 2, label: 'Não' },
					],
					tiposVoucher: [
						{ value: "nceComplementar", label: "NCE Complementar" },
						{ value: "cdfComplementar", label: "CDF Complementar" },
						{ value: "cancelamento", label: "Cancelamento" },
						{ value: "red", label: "Red Week" }
					],
					categoriasLoja: null,
					tiposDesconto: null,
				}
			}
    },
    mounted () {
			// console.log('scope:', this.scope)
			this.editVoucher = UserService.filterPermissions('editVoucher')
			this.createEditTipoVoucher = UserService.filterPermissions('createEditTipoVoucher')

			if ( this.scope ) {
				this.tipoVoucher = Object.assign({}, this.scope)
				// this.getTipoVoucher()
				this.getCategoriasLoja()
				this.getTipoDescontos()
			}
    },
    methods: {
			getTipoVoucher() {
				MarketplaceService.getTipoVoucher(0)
				.then((response) => {
					console.log("getTipoVoucher:", response.data)
					
					this.options.tiposVoucher = createSelectOptions(response.data,'tipo','tipo')
					console.log("getTipoVoucher:", this.tiposVoucher)
					this.wait.tiposVoucher = true
					this.finishLoad()
					
				})
				.catch( error => {
					console.error(error)
				})
			},
			getCategoriasLoja () {
				MarketplaceService.getCategorias()
				.then( response => {
					console.log('getCategorias:', response.data)
					const categorias = response.data.filter( a => a.ativo )
					this.options.categoriasLoja = createSelectOptions(categorias,'idcategorialoja', 'descricao')
					this.wait.categoriasLoja = true
					this.finishLoad()
				})
				.catch( error => console.error(error))
			},
			getTipoDescontos () {
				MatriculaService.getDescontos().then(
					response => {
						console.log('getTipoDescontos:', response.data)
						this.options.tiposDesconto = createSelectOptions(response.data, 'idTipoDesconto','descricao')

						this.wait.tipoDesconto = true
						this.finishLoad()
					})
					.catch( error => console.error(error))
			},
			finishLoad () {
				const done = !Object.values(this.wait).some( a => !a)
				console.log("done:", done)
				if ( done ) {
					this.ready = true
				}
			},
			maskMoney(e,step, field) {
				let value = e.target.value ?? ''

				// Se apagou tudo: limpa o model e libera o outro campo
				if (value === '') {
					this.tipoVoucher[field] = null
					return
				}

				// normaliza
				value = String(value).replace(',', '.')

				const regex = new RegExp(`^\\d+(\\.\\d{0,${step}})?$`)
				if (!regex.test(value)) {
					value = value.slice(0, -1)
					e.target.value = value

					// se ficou vazio depois do slice, limpa o model
					if (value === '') this.tipoVoucher[field] = null
				}

				// garante que o model acompanha o input (number)
				this.tipoVoucher[field] = value === '' ? null : Number(value)
			},
			clear () {
				this.tipoVoucher = Object.assign({}, this.model)
				console.log("clear:", this.model)
			},
			saveTipoVoucher () {
				const { idTipoVoucher } = this.tipoVoucher
				const payload = Object.assign({}, this.tipoVoucher)

				if ( !this.editVoucher ) {
					window.toaster.emit('open', { style: 'error', message: 'Você não tem permissão para editar uma categoria de voucher.', floater: true })
					return false
				}
				window.spinner.emit('open')
				FinanceiroService.saveTipoVoucher(idTipoVoucher, payload ).then(
					response => {
						console.log('saveTipoVoucher:', response.data)
						window.toaster.emit('open', { style: 'success', message: 'Tipo de voucher salvo com sucesso', floater: true })
					}
				).catch (
					error => {
						console.error(error)
						window.toaster.emit('open', { style: 'error', message: `Ops! Algo aconteceu. Não foi possível salvar essa categoria de voucher. ${error}`, floater: true })
					}
				).finally(() => {
					window.spinner.emit('close')
				})
			}
		}
}	


</script>



<style lang="scss" scoped>
section > div {
	&.locked {
		pointer-events: none;
		opacity: .7;
	}
}
form {
    display: flex;
    flex-direction: column;
}

footer {
    display: flex;
    justify-content: space-between;
    width: 100%;
		border-top: $border-component;
		margin-top: $hmg_mid; padding-top: $hmg_mid;
}

.lockMsg {
	padding: $hmg_small !important;
	display: flex;
	align-items: center;
	background-color: $color-alert;
	color: $color-secondary;
	gap: $hmg_mini;
	border-radius: $border-radius;
	margin-bottom: $hmg_mid;
	
	p {
		margin: 0; padding: 0;
	}
}
.frame {
    padding: $hmg_mid;


    h3 {
        display: flex;
        height: $mg;
    }
}
.form-actions {
    margin-top: 0
}

</style>